// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
// import 'firebase/database'; // If you're using the Realtime Database
// import 'firebase/firestore'; // If you're using Firestore

const firebaseConfig = {
  apiKey: "AIzaSyB98OeqmrLrSkgqjVwU4mVnxF-Yf8IM-_0",
  authDomain: "portfolio-2f021.firebaseapp.com",
  projectId: "portfolio-2f021",
  storageBucket: "portfolio-2f021.appspot.com",
  messagingSenderId: "575978265077",
  appId: "1:575978265077:web:e9f522965fb19aadd328bc",
  measurementId: "G-L5VMJLJH1N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get the Firestore instance
const db = getFirestore(app);

// Export what you need
export { app, db };

